import { render, staticRenderFns } from "./product-advantages-item-SupplierQualityAnalysis.vue?vue&type=template&id=15d93659&scoped=true"
import script from "./product-advantages-item-SupplierQualityAnalysis.vue?vue&type=script&lang=js"
export * from "./product-advantages-item-SupplierQualityAnalysis.vue?vue&type=script&lang=js"
import style0 from "./product-advantages-item-SupplierQualityAnalysis.vue?vue&type=style&index=0&id=15d93659&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d93659",
  null
  
)

export default component.exports